import {Routes} from '@angular/router';
import {HomeComponent} from './components/home/home.component';
import {NotFoundComponent} from './components/not-found/not-found.component';
import {authenticationGuard} from './guards/authentication/authentication.guard';
import {LoginComponent} from './components/login/login.component';
import {TermsAndConditionsComponent} from './components/terms/terms-and-conditions/terms-and-conditions.component';
import {DataProtectionComponent} from './components/terms/data-protection/data-protection.component';
import {ImpressumComponent} from './components/terms/impressum/impressum.component';
import {OrderFormComponent} from './components/order-form/order-form.component';
import {OrderHistoryComponent} from "./components/order-history/order-history.component";
import {PaymentSuccessfulComponent} from "./components/payment-successful/payment-successful.component";
import { ConfirmMailPageComponent } from './components/service-pages/confirm-mail-page/confirm-mail-page.component';
import { ForgotPasswordPageComponent } from './components/service-pages/forgot-password-page/forgot-password-page.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
        title: 'Home'
    },
    {
        path: 'home',
        component: HomeComponent,
        title: 'Home',
        canActivate: [authenticationGuard],
    },
    {
        path: 'anmeldung',
        component: LoginComponent,
        title: 'Anmelden'
    },
    {
        path: 'agb',
        component: TermsAndConditionsComponent,
        title: 'AGB'
    },
    {
        path: 'datenschutz',
        component: DataProtectionComponent,
        title: 'Datenschutz'
    },
    {
        path: 'impressum',
        component: ImpressumComponent,
        title: 'Impressum'
    },
    {
        path: 'bestellung/:orderHash',
        component: OrderFormComponent,
        title: 'Bestellung'
    },
    {
        path: 'bezahlung-erfolgreich',
        component: PaymentSuccessfulComponent,
        title: 'Bezahlung erfolgreich'
    },
    {
        path: 'bestellungen',
        component: OrderHistoryComponent,
        title: 'Bestellhistorie',
        canActivate: [authenticationGuard],
    },
    {
        path: 'email-bestaetigen/:uuid',
        component: ConfirmMailPageComponent,
        title: 'E-Mail bestätigen'
    },
    {
        path: 'email-bestaetigen/:registerToken/validate',
        component: ConfirmMailPageComponent,
        title: 'E-Mail bestätigen'
    },
    {
        path: 'not-found',
        component: NotFoundComponent,
        title: 'Seite nicht gefunden'
    },
    {
        path: 'passwort-zuruecksetzen/:uuid',
        component: ForgotPasswordPageComponent,
        title: 'Passwort zurücksetzen'
    },
    {
        path: '**',
        redirectTo: 'not-found',
        title: 'Seite nicht gefunden'
    }
];
